import functions from '../functions.js';
import { details } from './details';
import { DetailsCart } from './details-cart.js';

const $detailsNavAccommodationTab = $('#details-nav-accommodation-tab');

$(() => {
    detailsAccommodation.init();

    $detailsNavAccommodationTab.on('shown.bs.tab', e => {

        $('.departure-bus-ticket').addClass('d-none');
        $('.departure-sopstveni').removeClass('d-none');

    });
});

const detailsAccommodation = {
    $details: null,
    $booking: null,
    $form: null,
    form: null,
    $cart: null,
    cart: [],
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
    },
    init() {
        this.$details = $('.page-type-details');
        this.$booking = $('#booking');
        this.params.objectGroupId = this.$booking.attr('data-objectgroupid');
        this.params.currencyIdTo = this.$booking.attr('data-currencyidto');

        this.isBookingTabs = $('.booking-tabs').length;

        if( ! (this.$details[0] && this.params.objectGroupId === "1" && +this.$booking.attr('data-dynamicpackage') === 0)) {
            return;
        }

        if($('[data-isFixDepartures]').attr('data-isFixDepartures')) {
            return;
        }

        this.$form = $('.availability-form-accommodation');
        this.form = this.$form[0];

        this.params.objectId = this.$booking.attr('data-objectid');
        this.params.calcErrorMessages = this.$booking.attr('data-calcErrorMessages') ? JSON.parse(this.$booking.attr('data-calcErrorMessages')) : null;

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }
        
        if(this.form) {
            functions.setFormData(this.form, this.params);
        }

        const formData = functions.getFormData(this.$form);
        this.params.serviceCode = formData.serviceCode ? formData.serviceCode : null;

        this.setActiveDeparture();

        this.getCalculation();
        
        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            this.params.unitId = null;

            functions.setUrlData(params, true, true);

            //detailsAccommodation.params = functions.getFormData($(e.currentTarget));
            //detailsAccommodation.params.unitId = null;
            //functions.setUrlData(detailsAccommodation.params, true, true);
        });

        // check availability on form change (not only on btn click)
        $('[name="dates"], [name=guests], [name=serviceCode]').on('change', () => {
            const data = functions.getFormData(this.$form);
            if ( data.dates && data.guests ) {
                this.$form.trigger('submit');
            }
        });

        this.$cart = $('.details-cart');
        this.cart = this.$cart.length ? new DetailsCart(this.params) : [];

        $('.btn-book-one-unit').on('click', e => {
            const $target = $(e.currentTarget);

            if (! this.params.dateFrom || ! this.params.dateTo || ! this.params.guests) {
                window.setAlertBooking($target);
                let $alertBooking = $target.closest('.unit').find('.alert-booking');
                $alertBooking.addClass('active');
                setTimeout(() => {
                    $alertBooking.removeClass('active');
                }, 4000);
            }
        });

        $('.departure-bus-ticket').addClass('d-none');
        $('.departure-sopstveni').removeClass('d-none');

        $(window).on('hashchange', e => {
            this.getParams();
            //this.params.guests = this.params.adultsOnly ? this.params.guests.split(',')[0] + ',0' : this.params.guests;
            this.setActiveDeparture();

            if (! $('#details-nav-bus-package-tab').length) {
                this.params.aDateFrom = this.params.dateFrom;
                this.params.aDateTo = this.params.dateTo;
            }

            //this.getCalculation(this.params);
            $detailsNavAccommodationTab.hasClass('active') && this.getCalculation(this.params);
        });
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates === '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;

        if (cParams.aDateFrom && cParams.aDateTo) {
            cParams.dateFrom = cParams.aDateFrom;
            cParams.dateTo = cParams.aDateTo;
        } else {
            cParams.aDateFrom = cParams.dateFrom;
            cParams.aDateTo = cParams.dateTo;
        }

        const calculation = details.getCalculation(cParams);

        if(calculation) {
            details.unitsSpinner();
            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                console.log(error);
            });
        } else {

            //$('.block-no-dates').removeClass('d-none');
            //$('.block-discount').removeClass('d-none');
            //$('.block-loading').addClass('d-none');
        }

        //$('.block-totals-per-service').addClass('d-none');
        //$('.block-booking').addClass('d-none');
        //$('.block-error-msg').addClass('d-none');
    },
    calculationDone(response, params) {
        if(response.status) {
            //console.log(response);
            const data = response.data || [];
            let cancellationPolicy = response.cancellationPolicy || [];

            // cancellationPolicy data example
            /*cancellationPolicy = {
                deadlineDate: "0001-01-01T00:00:00",
                items: [
                    {
                        BeginDate: "2027-01-03",
                        ChargedDay: null,
                        EndDate: "2027-01-21",
                        Percent: "100",
                        ReleaseDayFrom: "5",
                        ReleaseDayTo: "7",
                    },
                ]
            };*/

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = this.isBookingTabs ? $('#details-nav-accommodation .unit[data-unitid=' + unitId + ']') : $('.unit[data-unitid=' + unitId + ']');
                const $addToCart = $unit.find('.add-to-cart');
                const isBookable = details.isBookable(unitData);
                
                if (isBookable) {
                    const unitCalc = unitData.calc;
                    const total = unitCalc.currencySymbol + ' ' + functions.formatMoney(unitCalc.total, 0, '.', ',');
                    const calcItems = unitCalc.items;

                    let priceOld = 0.00;
                    let discountTitle = null;

                    calcItems.forEach(item => {
                        // popust za djecu ne ulazi u prikaz discount cijene
                        if ((item.itemType != 'discount' || item.itemDefinitionId == 129) && !item.optional && !item.onSpot) {
                            priceOld += item.itemTotal;
                        }
                        if (item.itemType == 'discount') {
                            discountTitle = item.itemTitle;
                            if (item.data && item.data.text) {
                                discountTitle = item.data.text;
                            }
                        }
                    });

                    let hasDiscount = priceOld && priceOld != unitCalc.total ? priceOld : null;

                    const totalOld = unitCalc.currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',');

                    $unit.find('.price').html(total);

                    if (hasDiscount) {
                        priceOld && $unit.find('.price-old').html(totalOld);
                        discountTitle && $unit.find('.badge-discount').html(discountTitle);
                        discountTitle && $unit.find('.badge-discount').removeClass('d-none');
                    } else {
                        $unit.find('.price-old').html('');
                        $unit.find('.badge-discount').addClass('d-none');
                    }

                    $unit.parent('div').prop('style', 'order: ' + Math.round(unitCalc.total) + ';');

                    $addToCart.attr('data-unitcarttotal', unitCalc.total);
                    $addToCart.attr('data-unitcarttotalold', priceOld);
                    $addToCart.attr('data-currencysymbol', unitCalc.currencySymbol);

                    $addToCart.attr('data-datefrom', detailsAccommodation.params.dateFrom);
                    $addToCart.attr('data-dateto', detailsAccommodation.params.dateTo);
                    $addToCart.attr('data-guests', detailsAccommodation.params.guests);

                    let $unitBtnBook = $('.btn-book-one-unit[data-unitid="' + unitId + '"]');
                    if ($unitBtnBook.length) {
                        //console.log($unitBtnBook);

                        let labelRequest = $unitBtnBook.data('labelrequest');
                        let labelBook = $unitBtnBook.data('labelbook');

                        $unitBtnBook.text(unitData.booking.status == 'Request' ? labelRequest : labelBook);
                    }

                } else {
                    $unit.parent('div').prop('style', 'order: 100000;');
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.unit-error-message').toggleClass('d-none', isBookable || unitData.message == "notAvailable");
                $unit.find('.unit-error-message').text(error);

                $unit.find('.rate-container').toggleClass('d-none', ! isBookable);
                $unit.find('.add-to-cart').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-book-one-unit').toggleClass('d-none', ! isBookable);
                $unit.find('.btn-request').toggleClass('d-none', isBookable);

                $unit.find('.price-from-label').toggleClass('d-none', isBookable);
                $unit.find('.unit-numberOfPersons').toggleClass('d-none', isBookable);
                $unit.find('.total-label').toggleClass('d-none', ! isBookable);

            });

            if (this.$cart.length && ! this.$cart.data('isgds')) {
                const $btnBooking = $('.btn-booking');

                $btnBooking.on('click', e => {
                    e.preventDefault();
                    let cartData = [];

                    this.cart.cartItems.forEach(item => {
                        item = JSON.parse(item);
                        cartData.push({
                            'unitId': item.unitId,
                            'dateFrom': item.dateFrom,
                            'dateTo': item.dateTo,
                            'aDateFrom': item.aDateFrom,
                            'aDateTo': item.aDateTo,
                            'guests': item.guests,
                            'serviceCode': item.serviceCode,
                            'serviceId': item.serviceId,
                            'pricelistId': params.pricelistId,
                            'dynamicPackage': 0,
                        });
                    });
                    let url = $(e.currentTarget).attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true&dynamicPackage=0&currencyIdTo=' + detailsAccommodation.params.currencyIdTo;

                    if(this.cart.cartItems.length) {
                        location = url;
                    } else {
                        $('#detailsCartModal').modal('show');
                        setTimeout(() => {
                            $('#detailsCartModal').modal('hide');
                        }, 2500);
                    }
                });
            } else {

                detailsAccommodation.getParams();
                
                $('.btn-book-one-unit').on('click', e => {
                    const $target = $(e.currentTarget); 

                    let cartData = [
                        {
                            'unitId': $target.attr('data-unitId'),
                            'dateFrom': detailsAccommodation.params.dateFrom,
                            'dateTo': detailsAccommodation.params.dateTo,
                            'guests': detailsAccommodation.params.guests,
                            'serviceCode': detailsAccommodation.params.serviceCode,
                            //'dynamicPackage': 0,
                        }
                    ];

                    location = $target.attr('data-href') + '?cart_data=' + JSON.stringify(cartData) + '&addAllOptionals=true'; // &dynamicPackage=0
                });
            }

            if (cancellationPolicy && cancellationPolicy.items) {

                //console.log(cancellationPolicy);

                let cancellationPolicyHtml = `
                    <div class="cancellation-policy-wrapper pb-3">
                        <div class="cancellation-policy border border-primary rounded p-3">
                            <div class="d-flex">
                                <i class="fa-solid fa-times-circle text-danger me-2"></i>
                                <h6 class="text-uppercase">Uvjeti otkaza</h6>
                            </div>
                `;

                cancellationPolicy.items.forEach(item => {
                    cancellationPolicyHtml += item.Percent 
                        ? `<div>Otkazivanje <strong>${item.ReleaseDayFrom} - ${item.ReleaseDayTo} dana</strong> prije dolaska: naknada za otkazivanje iznosi <strong>${item.Percent}%</strong> ukupnog iznosa.</div>` 
                        : '';
                })

                cancellationPolicyHtml += `
                        </div>
                    </div>
                `;

                if ($('.units .cancellation-policy-wrapper').length) {
                    $('.units .cancellation-policy-wrapper').remove();
                }

                //$('.units').append(cancellationPolicyHtml);
            }
        }
    },
    setActiveDeparture() {
        if (this.params.dateFrom && this.params.dateTo) {
            const dateFrom = new Date(this.params.dateFrom);
            const dateTo = new Date(this.params.dateTo);
            const diffInMs = dateTo.getTime() - dateFrom.getTime();
            const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

            const $departureSelection = $('.departure-selection');
            $departureSelection.find('.departure-dateFrom').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));
            $departureSelection.find('.departure-duration').text(diffInDays + ' noćenja');

            $('.accordion-summary .departure-dateFrom').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));
            
        } else {
            $('.details-cart').find('.departure-dateFrom').html(`
                <a href="" data-scroll-to="#booking,120">Odaberite datume putovanja</a>
            `);
        }

        if (this.params.guests) {
            let guests = this.params.guests.split(',');
            $('.details-cart').find('.departure-guests').html(`
                ${ guests[0] } odrasli${ +guests[1] ? ', ' + guests[1] + ( +guests[1] == 1 ? ' dete' : ' dece') : ''}
            `);
        } else {
            $('.details-cart').find('.departure-guests').html(`
                <a href="" data-scroll-to="#booking,120">Odaberite broj gosta</a>
            `);
        }
    }
};